import React from 'react';
import { Query } from '@apollo/client/react/components';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const SubscribeCurrentUser = require('buyside/graphql/queries/SubscribeCurrentUser');

import { SubscribeCurrentUserQuery } from 'interfaces/graphql-typings';

import Subscribe from 'buyside/components/presentation/Subscribe/Subscribe';

import { determineAvailablePlans } from 'buyside/components/presentation/Subscribe/subscribeUtil';
import { STRIPE_PLANS } from 'interfaces/payment/plans';

const SubscribeContainer: React.FunctionComponent = (): React.ReactElement => {
  return (
    <Query<SubscribeCurrentUserQuery> query={SubscribeCurrentUser}>
      {({ loading, data }): React.ReactElement | null => {
        if (loading || !data || !data.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;
        const { currentUser } = data;
        const { isRetail, isEliteTier, subscriptions } = currentUser;

        return (
          <Subscribe
            plans={determineAvailablePlans(currentUser)}
            isRetail={isRetail}
            subscriptions={subscriptions}
            userTier={subscriptions && isEliteTier ? STRIPE_PLANS.retailTier1 : null}
          />
        );
      }}
    </Query>
  );
};

export default SubscribeContainer;
